export default {
  appName: 'vuemusic',
  apiKey:'055a106327941b224d5a095a62aa3fc2',
  secret: '0d28fb1b06ace0d023ec1a37c704fe0d',
  registeredTo: 'danielpqe'
}



// Application name	vuemusic
// API key	055a106327941b224d5a095a62aa3fc2
// Shared secret	0d28fb1b06ace0d023ec1a37c704fe0d
// Registered to	danielpqe



// WEBPACK FOOTER //
// ./src/api/config.js